import {actionTypes} from './constants'
import {CreateClientPayload} from '../Model'

export const actions = {
  // List
  getClients: () => ({type: actionTypes.GET_OAUTH_CLIENTS_REQUEST}),
  getClientsSuccess: (data: any) => ({type: actionTypes.GET_OAUTH_CLIENTS_SUCCESS, payload: data}),
  getClientsFinish: (errorMsg?: any) => ({
    type: actionTypes.GET_OAUTH_CLIENTS_FINISH,
    payload: errorMsg,
  }),

  // Create
  createClient: (data: CreateClientPayload) => ({
    type: actionTypes.CREATE_OAUTH_CLIENT_REQUEST,
    payload: data,
  }),
  createClientSuccess: (data: any) => ({
    type: actionTypes.CREATE_OAUTH_CLIENT_SUCCESS,
    payload: data,
  }),
  createClientFinish: (errorMsg?: any) => ({
    type: actionTypes.CREATE_OAUTH_CLIENT_FINISH,
    payload: errorMsg,
  }),
  createClientReset: () => ({type: actionTypes.CREATE_OAUTH_CLIENT_RESET}),

  // Revoke
  revokeClient: (id: string) => ({type: actionTypes.REVOKE_OAUTH_CLIENT_REQUEST, payload: id}),
  revokeClientSuccess: (data: any) => ({
    type: actionTypes.REVOKE_OAUTH_CLIENT_SUCCESS,
    payload: data,
  }),
  revokeClientFinish: (errorMsg?: any) => ({
    type: actionTypes.REVOKE_OAUTH_CLIENT_FINISH,
    payload: errorMsg,
  }),

  // Delete
  deleteClient: (id: string) => ({type: actionTypes.DELETE_OAUTH_CLIENT_REQUEST, payload: id}),
  deleteClientSuccess: (data: any) => ({
    type: actionTypes.DELETE_OAUTH_CLIENT_SUCCESS,
    payload: data,
  }),
  deleteClientFinish: (errorMsg?: any) => ({
    type: actionTypes.DELETE_OAUTH_CLIENT_FINISH,
    payload: errorMsg,
  }),

  // Tokens
  getTokens: (id: string) => ({type: actionTypes.GET_OAUTH_TOKENS_REQUEST, payload: id}),
  getTokensSuccess: (data: any) => ({type: actionTypes.GET_OAUTH_TOKENS_SUCCESS, payload: data}),
  getTokensFinish: (errorMsg?: any) => ({
    type: actionTypes.GET_OAUTH_TOKENS_FINISH,
    payload: errorMsg,
  }),
}
